import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

function ImageDialogTrigger({
  src,
  alt,
  triggerClassName = '',
  imageClassName = '',
  caption,
  expandLabel,
  closeLabel = 'Fechar imagem ampliada'
}) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      document.body.style.overflow = '';
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);

  const buttonClassName = [triggerClassName, 'image-dialog-trigger'].filter(Boolean).join(' ');
  return (
    <>
      <button
        type="button"
        className={buttonClassName}
        onClick={() => setIsOpen(true)}
        aria-label={expandLabel || `Ampliar imagem: ${alt}`}
      >
        <img src={src} alt={alt} className={imageClassName} />
      </button>

      {isOpen && typeof document !== 'undefined' && createPortal(
        <dialog className="image-dialog" aria-label={alt} open>
          <button
            type="button"
            className="image-dialog-backdrop"
            onClick={() => setIsOpen(false)}
            aria-label={closeLabel}
          />
          <div className="image-dialog-content">
            <button
              type="button"
              className="image-dialog-close"
              onClick={() => setIsOpen(false)}
              aria-label={closeLabel}
            >
              ×
            </button>
            <img src={src} alt={alt} className="img-fluid image-dialog-full-image" />
          </div>
        </dialog>,
        document.body
      )}
    </>
  );
}

ImageDialogTrigger.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  triggerClassName: PropTypes.string,
  imageClassName: PropTypes.string,
  caption: PropTypes.string,
  expandLabel: PropTypes.string,
  closeLabel: PropTypes.string
};

export default ImageDialogTrigger;